<template>
  <div class="w-100 h-100 m-0" style="padding: 32px">
    <div class="d-flex flex-column" style="gap: 40px;">
      <div class="m-0 p-0 acry-page-title justify-content-center">チケット詳細</div>
      <!-- パンクズ -->
      <div class="d-flex" style="gap: 14px; font-size: 13px;">
        <div class="c-pointer" style="text-decoration: underline;" @click="onClickReturnTop()" >
          ACRY TICKET TOP
        </div>
        <div>＞</div>
        <div class="c-pointer" style="text-decoration: underline;" @click="onClickReturnList()" >
          チケット一覧
        </div>
        <div>＞</div>
        <div>チケット詳細</div>
      </div>

      <!-- イベント内容 -->
      <div class="d-flex flex-column text-start" style="padding: 32px; border: 1px solid #BDBDBD;">
        <div class="m-0 p-0 acrypro-text-main-bold" style="height: 35px; border-bottom: solid 1px #8C9BC6;">
          イベント内容
        </div>

        <div class="d-flex un-edited" style="padding: 8px 0px 32px 0px; border-bottom: solid 1px #E0E0E0; gap: 64px;">
          <div class="acrypro-text-main-bold" style="width: 190px;">
            デザインサイズ
          </div>
          <div class="flex-grow-1" style="font-size: 15px;">
            {{this.settingData.size}}
          </div>
        </div>

        <div class="d-flex un-edited" style="padding: 8px 0px 32px 0px; border-bottom: solid 1px #E0E0E0; gap: 64px;">
          <div class="acrypro-text-main-bold" style="width: 190px;">
            チケット使用者編集
          </div>
          <div v-if="this.settingData.isUserEdit" class="flex-grow-1" style="font-size: 15px;">
            可
          </div>
          <div v-if="!this.settingData.isUserEdit" class="flex-grow-1" style="font-size: 15px;">
            不可
          </div>
        </div>

        <div class="d-flex un-edited" style="padding: 8px 0px 32px 0px; border-bottom: solid 1px #E0E0E0; gap: 64px;">
          <div class="acrypro-text-main-bold" style="width: 190px;">
            送料負担
          </div>
          <div v-if="this.settingData.isShippingFee" class="flex-grow-1" style="font-size: 15px;">
            チケット使用者負担
          </div>
          <div v-if="!this.settingData.isShippingFee" class="flex-grow-1" style="font-size: 15px;">
            チケット発行者負担
          </div>
        </div>

        <div class="d-flex" style="padding: 8px 0px 32px 0px; border-bottom: solid 1px #E0E0E0; gap: 64px;">
          <div class="acrypro-text-main-bold" style="width: 190px;">
            プロジェクト名
          </div>
          <div class="d-flex flex-column flex-grow-1" style="gap:16px;">
            <input class="flex-grow-1 w-100 acry-input" style="padding:10px; height:40px;" type="text" placeholder="〇〇プロジェクト" v-model="eventName"/>
            <div class="acrypro-text-main" style="font-size:12px;">
              <p class="m-0">● この名称はプロジェクトを管理するためのものです。チケット使用者には表示されません。</p>
            </div>
          </div>
        </div>

        <div class="d-flex" style="padding: 8px 0px 32px 0px; border-bottom: solid 1px #E0E0E0; gap: 64px;">
          <div class="acrypro-text-main-bold d-flex justify-content-between" style="width:190px;">
            <div>発行者名</div>
            <div class="input-required d-flex">
              <div class="m-auto">必須</div>
            </div>
          </div>
          <div class="d-flex flex-column flex-grow-1" style="gap:16px;">
            <input class="flex-grow-1 w-100 acry-input" style="padding:10px; height:40px;" type="text" placeholder="発行者名" v-model="eventIssuerName"/>
            <div class="acrypro-text-main" style="font-size:12px;">
              <p class="m-0">● ACRYアプリのPRページ上に表示されます。</p>
              <!-- <p class="m-0">・変更はお客様情報で変更可能です</p> -->
            </div>
          </div>
        </div>

        <div class="d-flex" style="padding: 8px 0px 32px 0px; height:390px; gap: 48px; border-bottom: solid 1px #E0E0E0">
          <div class="acrypro-text-main-bold d-flex justify-content-between" style="width:190px;">
            <div>アクリルデザイン</div>
            <div class="input-required d-flex">
              <div class="m-auto">必須</div>
            </div>
          </div>
          <div class="d-flex flex-column" style="gap: 8px;">
            <div class="c-pointer" style="height: 320px; width: 200px;" @click="onClickDesignUpload">
              <img v-if="this.$store.state.eventCreateData.previewData" class="w-100 h-100" style="object-fit: contain; dashed 1px #D1D5DB; background: #FFFFFF;" :src="this.$store.state.eventCreateData.previewData.fileURL" />
              <img v-if="!this.$store.state.eventCreateData.previewData" class="w-100 h-100" style="object-fit: contain;" src="@/assets/acrypro/coupon/upload_design.svg" />
            </div>
            <div class="m-0" style="height: 40px; font-size: 12px;">
            <p class="m-0">※有効期限内に内容を変更された場合、トラブルが発生しても当社では対応いたしかねます。</p>
            </div>
          </div>
        </div>

        <div class="d-flex" style="padding: 8px 0px 32px 0px;  gap: 64px;">
          <div class="acrypro-text-main-bold" style="width: 190px;">
            PR画像
          </div>
          <div class="d-flex flex-column flex-grow-1" style="gap:16px;">

            <!-- 説明 -->
            <div style="font-size: 12px;">
              <p class="m-0">● <span style="color: #BC6665;">画像は必須ではありません。</span></p>
              <p class="m-0">● <span class="c-pointer" style="text-decoration: underline; color: #8C9BC6;" @click="setModal(true)">PR画像について</span></p>
            </div>
            <div class="text-start" style="margin-top: 12px; font-size: 12px;">
              <p class="m-0">【サイズ】</p>
              <p class="m-0">・1枚目上部…ヨコ{{AcryTicketData.PRImage1X}}×タテ{{AcryTicketData.PRImage1Y}}px</p>
              <p class="m-0">・2枚目下部…ヨコ{{AcryTicketData.PRImage2X}}×タテ最大{{AcryTicketData.PRImage2Y}}px</p>
              <p class="m-0">・1枚{{AcryTicketData.PRImageMaxSize}}MB以下</p>
              <p class="mb-0" style="margin-top: 16px;">【アップロード形式】</p>
              <p class="m-0">・PNG、JPEG</p>
            </div>

            <!-- バナー -->
            <div class="d-flex" style="gap:16px; margin-top: 8px;">
              <div class="d-flex flex-column" style="gap: 8px;">
                <div style="font-size: 12px;">
                  <p class="m-0">1枚目上部（ヨコ{{AcryTicketData.PRImage1X}}×タテ{{AcryTicketData.PRImage1Y}}）</p>
                </div>
                <div class="position-relative" style="height:200px; width:200px;">
                  <label class="position-relative c-pointer h-100 w-100"
                    ><input
                      type="file"
                      ref="bannerData1"
                      accept=".png,.jpg,.jpeg"
                      @change="uploadBannerData1"
                    />
                    <img v-if="this.$store.state.eventCreateData.bannerData1" class="w-100 h-100 m-auto" style="object-fit: contain; border: dashed 1px #B1C0DB; background: #FFFFFF;" :src="this.$store.state.eventCreateData.bannerData1.fileURL" />
                    <img v-if="!this.$store.state.eventCreateData.bannerData1" class="w-100 h-100 m-auto" style="object-fit: contain;" src="@/assets/acrypro/coupon/banner1_upload.svg" />
                  </label>
                  <img v-if="this.$store.state.eventCreateData.bannerData1" src="@/assets/acrypro/upload_cross.svg" class="position-absolute" style="height:16px; width:16px;right: 8px;top: 8px;cursor: pointer;" @click="deleteBanner1()">
                </div>
              </div>
              <div class="d-flex flex-column" style="gap: 8px;">
                <div style="font-size: 12px;">
                  <p class="m-0">2枚目下部（ヨコ{{AcryTicketData.PRImage2X}}×タテ最大{{AcryTicketData.PRImage2Y}}）</p>
                </div>
                <div class="position-relative" style="height:200px; width:200px; ">
                  <label class="position-relative c-pointer h-100 w-100"
                    ><input
                      type="file"
                      ref="bannerData2"
                      accept=".png,.jpg,.jpeg"
                      @change="uploadBannerData2"
                    />
                    <img v-if="this.$store.state.eventCreateData.bannerData2" class="w-100 h-100 m-auto" style="object-fit: contain; border: dashed 1px #B1C0DB; background: #FFFFFF;" :src="this.$store.state.eventCreateData.bannerData2.fileURL" />
                    <img v-if="!this.$store.state.eventCreateData.bannerData2" class="w-100 h-100 m-auto" style="object-fit: contain;" src="@/assets/acrypro/coupon/banner1_upload.svg" />
                  </label>
                  <img v-if="this.$store.state.eventCreateData.bannerData2" src="@/assets/acrypro/upload_cross.svg" class="position-absolute" style="height:16px; width:16px;right: 8px;top: 8px;cursor: pointer;" @click="deleteBanner2()">
                </div>
              </div>
            </div>

            <div class="c-pointer fw-bold" style="margin: 0px 24px; text-decoration: underline; color: #8C9BC6; font-size: 16px;" @click="setPreviewModal(true)">
              PRページプレビュー
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-center" style="gap:32px; border-radius: 20px; background: #F8F8F8; padding: 16px 0px;">
          <button class="m-0 acry-btn-sub fw-bold" style="width: 240px; height: 38px; border-radius: 100px; font-size: 16px;" @click="onClickReturnList">
            もどる
          </button>
          <button class="m-0 acry-btn fw-bold" style="width: 240px; height: 38px; border-radius: 100px; font-size: 16px;" @click="onClickEventUpdate">
            イベント内容を更新
          </button>
        </div>
      </div>


      <!-- イベント内容 -->
      <div class="d-flex flex-column text-start" style="padding: 32px; border: 1px solid #BDBDBD;">
        <div class="m-0 p-0 acrypro-text-main-bold" style="height: 35px; border-bottom: solid 2px #8C9BC6;">
          チケットコード発行
        </div>
        <div style="margin: 16px 0px;">
          <p class="m-0">チケットコードを発行することができます。</p>
          <!-- <p class="m-0">ACRY  TICKET (コード)を発行することができます。</p> -->
          <!-- <p class="m-0">コード発行画面では、<span class="fw-bold">枚数・有効期限</span>を決めていただき、枚数に応じて決済を行います。</p> -->
        </div>
        <div class="d-flex justify-content-center" style="gap:32px; border-radius: 20px; background: #F8F8F8; padding: 24px 0px;">
          <button class="m-0 acry-btn-sub fw-bold" style="width: 240px; height: 38px; border-radius: 100px; font-size: 16px;" @click="onClickIssueCodeHistory">
            発行コード履歴
          </button>
          <button class="m-0 acry-btn fw-bold" style="width: 240px; height: 38px; border-radius: 100px; font-size: 16px;" @click="onClickIssueCode(false)">
            チケットコード発行
          </button>
        </div>
        <!-- <div style="margin: 16px 0px;">
          <p class="m-0">テスト用はこちらで発行を行ってください</p>
        </div>
        <div class="d-flex justify-content-center" style="gap:32px; border-radius: 20px; background: #F8F8F8; padding: 24px 0px;">
          <p class="m-auto fw-bold cursor-pointer" style="color: #8C9BC6;" @click="onClickIssueCode(true)">サンプル用チケットコード発行</p>
        </div> -->
      </div>

      <!-- 削除 -->
      <div v-if="beforeIssue" class="d-flex text-start justify-content-center align-items-center" style="height: 70px; padding: 8px; border-radius: 10px; background: #FFF6F6; gap: 64px;">
        <div class="c-pointer fw-bold" style="text-decoration: underline; font-size: 16px;" @click="onClickStop()" >
          削除する
        </div>
        <div class="d-flex flex-column" style="font-size: 12px;">
          <p class="m-0">コード発行前のみ削除を行えます。</p>
          <p class="m-0">削除を行うとデータの復元は行えません。</p>
        </div>
      </div>
    </div>



    <!-- PR説明モーダル -->
    <div v-if="isModal" class="modal-bg" @click="setModal(false)">
      <div class="d-flex flex-column justify-content-center align-items-center position-relative" style="width: 900px; height: 700px; border-radius: 8px; background: #FEFEFE; padding: 40px 0px; gap: 24px;" v-on:click.stop="">
        <img class="position-absolute c-pointer" style="top: 40px; right: 40px;" src="@/assets/acrypro/close.svg" @click="setModal(false)">
        <div class="fw-bold" style="font-size: 28px;">
          PR画像について
        </div>
        <div class="text-start" style="font-size: 14px;">
          <p class="m-0">アクリルプレートのデザイン説明等の画像を用意していただく事で</p>
          <p class="m-0">より魅力的にアクリルプレートをPRすることが可能となります。</p>
        </div>
        <div class="d-flex justify-content-center mx-auto mb-auto" style="width: 750px; gap: 49px;">
          <div style="height: 470px;">
            <img class="h-100 w-100" src="@/assets/acrypro/coupon/pr_help1.png" style="object-fit: contain;" />
          </div>
          <div class="d-flex flex-column" style="">
            <div class="text-start" style="font-size: 15px; margin-bottom: 32px;">
              <p class="m-0">PR画像はACRYアプリのコード入力後のページに表示されます。</p>
              <p class="m-0">※画像は必須ではありません。</p>
              <p class="m-0">※PR画像がない場合テキストのみになります。</p>
            </div>
            <div style="height: 30px; width: 380px; background: #B1C0DB;">
              <p class="m-auto" style="color: #FFFFFF;">アップロード画像仕様</p>
            </div>
            <div class="text-start" style="margin-top: 16px;">
              <p class="m-0">【サイズ】</p>
              <p class="m-0">・1枚目上部…ヨコ1080×タテ1080px</p>
              <p class="m-0">・2枚目下部…ヨコ1080×タテ最大2000px</p>
              <p class="m-0">・1枚500MB以下</p>
              <p class="mb-0" style="margin-top: 16px;">【アップロード形式】</p>
              <p class="m-0">・PNG、JPEG</p>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- プレビューモーダル -->
    <div v-if="isPreviewModal" class="modal-bg" @click="setPreviewModal(false)">
      <div class="d-flex flex-column align-items-center position-relative" style="width: 900px; height: 700px; border-radius: 8px; background: #FEFEFE; padding: 40px 0px; gap: 24px;" v-on:click.stop="">
        <img class="position-absolute c-pointer" style="top: 40px; right: 40px;" src="@/assets/acrypro/close.svg" @click="setPreviewModal(false)">
        <div class="fw-bold" style="font-size: 28px;">
          PRページプレビュー
        </div>
        <div style="width: 370px; overflow-y: scroll;">
          <div class="container px-0 mx-0" style="background-color: #eeecf1">
            <div class="row align-items-center px-0 mx-0">
              <div class="col-12 px-0 mx-0">
                <img class="img-fluid w-100 mx-0 px-0" :src="image1Url" v-if="image1Url != ''"/>
              </div>
              <div class="col">
                <hr class="line" size="4"  />
              </div>
              <div class="col-auto">
                <span class="txt">使用期間</span>
              </div>
              <div class="col">
                <hr class="line" size="4" noshade="" />
              </div>
            </div>
            <div class="row align-items-center">
              <div class="col-12 text-center">
                <span class="txt">{{ periodStr }}</span>
              </div>
              <div class="col-12 px-4">
                <hr class="line" size="4" noshade="" />
              </div>
            </div>
            <div class="row">
              <div class="col text-start px-4">
                <span class="txtblack">クーポンコードで、アクリルプレートを作成することができます。</span>
              </div>
            </div>
            <div class="row my-3 ">
              <div class="col">
                <button class="btn btn-primary border-0 w-50" style="background-color: #8C9BC6;" @click="createAction"><span class="" style="font-size:14px">作る</span></button>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <img class="img-fluid w-100" :src="image2Url" v-if="image2Url != ''"/>
              </div>
            </div>
            <div class="row">
              <div class="col−12 my-3">
                <span class="txtblack">発行者:{{isserStr}}</span>
              </div>
            </div>
            <div class="row bg-white ms-4 me-4 pb-3 pt-3 rounded">
              <div class="col−12 text-center mb-2">
                <span class="txtblack">注意事項</span>
              </div>
              <div class="col−12">
                <ul class="text-start">
                  <li class="txtblack">利用する場合はACRYに会員登録する必要があります。</li>
                  <li class="txtblack">チケットコードは一度のみ使用可能です。</li>
                  <li class="txtblack">チケットコードは注文完了した時点で消費されます。</li>
                  <li class="txtblack">内容は予告なく変更になる場合がございます。</li>
                  <li class="txtblack">
                    チケット・デザインに関する事は発行者にお問い合わせください。
                  </li>
                </ul>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <span style="color: #eeecf1">a</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CenterViewState, RightViewState, AcryTicketData, GetAcryProTicketProductId, GetAcryTicketProductId } from "@/js/Const.js";
import { FileKit } from "@/js/FileKit.js";
import { FirebaseCommon } from "@/js/FirebaseCommon.js";
import { GenerateUUID } from "@/js/CommonFunc.js";


export default {
  name: "CenterViewEventEdit_Ap",
  props: {},
  data: function () {
    return {
      settingData:null,
      beforeIssue: false,
      // ticketIssueList:null,
      isModal: false,
      isPreviewModal: false,

      eventName:"",
      eventIssuerName:"",

      isUploadNewBanner1:false,  // 今回の編集で新規にバナーをアップロードしたかどうか
      isUploadNewBanner2:false,  // 今回の編集で新規にバナーをアップロードしたかどうか
    };
  },
  computed: {
    image1Url(){
      return this.$store.state.eventCreateData.bannerData1?.fileURL??"";
    },
    image2Url(){
      return this.$store.state.eventCreateData.bannerData2?.fileURL??"";
    },
    periodStr(){
      return "2025年01月01日 〜 2099年12月31日";
    },
    isserStr(){
      return this.eventIssuerName;
    },
    AcryTicketData(){
      return AcryTicketData;
    }
  },
  watch:{
    "eventName"(){
      this.$store.commit("setEventCreateEventName", this.eventName);
    },
    "eventIssuerName"(){
      this.$store.commit("setEventCreateEventIssuerName", this.eventIssuerName);
    },
  },
  async created() {
    this.$store.state.centerViewRef.scrollTop = 0;
    this.$store.commit("hideRightMenu");
    this.$store.commit("showLoading");

    this.settingData = this.$store.state.acrylicTicketCouponManager.selectEditSetting;

    // 初期データを設定
    this.eventName = this.$store.state.eventCreateData.eventName;
    this.eventIssuerName = this.$store.state.eventCreateData.eventIssuerName;

    // コードを発行したことがあるかチェック
    this.beforeIssue = !(await this.$store.state.acrylicTicketCouponManager.isTicketIssued(this.settingData.docId));

    this.$store.commit("hideLoading");
  },
  components: {
    
  },
  methods: {
    createAction(){

    },

    setModal(isModal){
      this.isModal = isModal;
    },
    setPreviewModal(isModal){
      this.isPreviewModal = isModal;
    },
    onClickReturnTop(){
      this.$store.commit("setCenterViewState", CenterViewState.EventManagement);
    },
    onClickReturnList(){
      this.$store.commit("setCenterViewState", CenterViewState.EventList);
    },
    async uploadBannerData1() {
      const file = this.$refs.bannerData1.files[0];
      // サイズ確認
      if( file.size > AcryTicketData.PRImageMaxSize * 1000000 ){
        this.$store.commit("showMessage", "データサイズが大きすぎます\n"+AcryTicketData.PRImageMaxSize+"MB以下にしてください");
        return;
      }

      // 拡張子確認
      const fileKit = new FileKit(file);
      if( !["png", "jpg", "jpeg"].includes(fileKit.extension) ){
        this.$store.commit("showMessage", "対応形式はPNG、JPEGのみです");
        return;
      }

      // 画像の大きさを確認
      const imageSize = await fileKit.getImageSize();
      if( imageSize.width != AcryTicketData.PRImage1X || imageSize.height != AcryTicketData.PRImage1Y ){
        this.$store.commit("showMessage", "画像のサイズは（ヨコ"+AcryTicketData.PRImage1X+"×タテ"+AcryTicketData.PRImage1Y+"）です");
        return;
      }

      // 新しいバナーを追加
      this.isUploadNewBanner1 = true;
      this.$store.commit("setEventCreateBannerData1", new FileKit(file));
    },
    async uploadBannerData2() {
      const file = this.$refs.bannerData2.files[0];
      // サイズ確認
      if( file.size > AcryTicketData.PRImageMaxSize * 1000000 ){
        this.$store.commit("showMessage", "データサイズが大きすぎます\n"+AcryTicketData.PRImageMaxSize+"MB以下にしてください");
        return;
      }

      // 拡張子確認
      const fileKit = new FileKit(file);
      if( !["png", "jpg", "jpeg"].includes(fileKit.extension) ){
        this.$store.commit("showMessage", "対応形式はPNG、JPEGのみです");
        return;
      }

      // 画像の大きさを確認
      const imageSize = await fileKit.getImageSize();
      if( imageSize.width != AcryTicketData.PRImage2X || imageSize.height > AcryTicketData.PRImage2Y ){
        this.$store.commit("showMessage", "画像のサイズは（ヨコ"+AcryTicketData.PRImage2X+"×タテ最大"+AcryTicketData.PRImage2Y+"）です");
        return;
      }

      // 新しいバナーを追加
      this.isUploadNewBanner2 = true;
      this.$store.commit("setEventCreateBannerData2", new FileKit(file));
    },

    deleteBanner1(){
      this.isUploadNewBanner1 = true;
      this.$store.commit("setEventCreateBannerData1", null);
    },

    deleteBanner2(){
      this.isUploadNewBanner2 = true;
      this.$store.commit("setEventCreateBannerData2", null);
    },

    // onClickReturn(){
    //   this.$store.commit("setCenterViewState", CenterViewState.EventManagement);
    // },

    async onClickEventUpdate(){

      this.$store.commit("showLoading");

      // データチェック
      if( !this.eventIssuerName ){
        this.$store.commit("hideLoading");
        this.$store.commit("showMessage", "発行者名を設定してください");
        return;
      }

      let data = {
        docId: this.$store.state.eventCreateData.docId??"",
        name: this.$store.state.eventCreateData.eventName,
        issuerName:this.$store.state.eventCreateData.eventIssuerName,
      };

      if( !this.$store.state.eventCreateData.folderName ){
        this.$store.commit("setEventCreateEventFolderName", GenerateUUID());
      }
      const folderName = this.$store.state.eventCreateData.folderName;

      // 新しくバナーをアップロードしている場合
      if(this.isUploadNewBanner1){
        this.$store.state.eventCreateData.bannerData1.rename();
        const bannerUrl = await FirebaseCommon.uploadFile(
          this.$store.state.eventCreateData.bannerData1.file,
          FirebaseCommon.getAcrylicTicketSettingBaseFilePath()+folderName+"/"+this.$store.state.eventCreateData.bannerData1.fileName);

        data.folderName = folderName;
        data.banner1 = bannerUrl;
      }

      // 新しくバナーをアップロードしている場合
      if(this.isUploadNewBanner2){
        this.$store.state.eventCreateData.bannerData2.rename();
        const bannerUrl = await FirebaseCommon.uploadFile(
          this.$store.state.eventCreateData.bannerData2.file,
          FirebaseCommon.getAcrylicTicketSettingBaseFilePath()+folderName+"/"+this.$store.state.eventCreateData.bannerData2.fileName);

        data.folderName = folderName;
        data.banner2 = bannerUrl;
      }

      let designUrl = "";
      if( this.$store.state.eventCreateData.designData ){
        this.$store.state.eventCreateData.designData.rename();
        designUrl = await FirebaseCommon.uploadFile(
          this.$store.state.eventCreateData.designData.file,
          FirebaseCommon.getAcrylicTicketSettingBaseFilePath()+folderName+"/"+this.$store.state.eventCreateData.designData.fileName);
        data.design = designUrl;
      }

      let cutlineUrl = "";
      if( this.$store.state.eventCreateData.cutlineData ){
        this.$store.state.eventCreateData.cutlineData.rename();
        cutlineUrl = await FirebaseCommon.uploadFile(
          this.$store.state.eventCreateData.cutlineData.file,
          FirebaseCommon.getAcrylicTicketSettingBaseFilePath()+folderName+"/"+this.$store.state.eventCreateData.cutlineData.fileName);
        data.cutline = cutlineUrl;
      }

      let nonEditableUrl = "";
      if( this.$store.state.eventCreateData.nonEditableData ){
        this.$store.state.eventCreateData.nonEditableData.rename();
        nonEditableUrl = await FirebaseCommon.uploadFile(
          this.$store.state.eventCreateData.nonEditableData.file,
          FirebaseCommon.getAcrylicTicketSettingBaseFilePath()+folderName+"/"+this.$store.state.eventCreateData.nonEditableData.fileName);
        data.nonEditable = nonEditableUrl;
      }

      let previewUrl = null;
      if( this.$store.state.eventCreateData.previewData ){
        this.$store.state.eventCreateData.previewData.rename();
        previewUrl = await FirebaseCommon.uploadFile(
          this.$store.state.eventCreateData.previewData.file,
          FirebaseCommon.getAcrylicTicketSettingBaseFilePath()+folderName+"/"+this.$store.state.eventCreateData.previewData.fileName);
        data.preview = previewUrl;
      }

      // イベントデータをセーブ
      await this.$store.state.acrylicTicketCouponManager.saveEventData(data).catch(() => {
        console.log("エラー");
      });

      this.$store.commit("hideLoading");

      this.$store.commit("showMessage", "データを更新しました");

      // this.$store.commit("setCenterViewState", CenterViewState.TicketIssueHistory);
    },


    onClickIssueCodeHistory(){
      this.$store.commit("setCenterViewState", CenterViewState.TicketIssueHistory);
    },

    onClickIssueCode( isSample ){
      // 発行時に必要なデータを設定
      // 注文用のデータを初期化
      this.$store.state.acrylicTicketCouponManager.resetOrderData();

      this.$store.state.acrylicTicketCouponManager.orderData.acrylicTicketSettingDocId = this.settingData.docId;
      this.$store.state.acrylicTicketCouponManager.orderData.isShippingFee = this.settingData.isShippingFee;
      this.$store.state.acrylicTicketCouponManager.orderData.isUserEdit = this.settingData.isUserEdit;
      this.$store.state.acrylicTicketCouponManager.orderData.preview = this.settingData.preview;
      this.$store.state.acrylicTicketCouponManager.orderData.isSample = isSample;

      // ACRY PRO側のプロダクトID
      const AcryProTicketProductId = GetAcryProTicketProductId(
        this.settingData.isShippingFee,
        this.settingData.size,
        isSample
      );
      this.$store.state.acrylicTicketCouponManager.orderData.ticketProductId = AcryProTicketProductId;

      // ACRY側のプロダクトID
      const AcryTicketProductId = GetAcryTicketProductId(
        this.settingData.isShippingFee,
        this.settingData.size,
        isSample
      );
      this.$store.state.acrylicTicketCouponManager.orderData.productId = AcryTicketProductId;

      this.$store.commit("setCenterViewState", CenterViewState.EventTicketIssue);
    },

    onClickDesignUpload(){
      this.$store.commit("setCenterViewState", CenterViewState.EventDesignUpload);
      this.$store.commit('setRightViewState', RightViewState.EventImageUpload);
    },
    formatDate(date) {
      const pad = (n) => n.toString().padStart(2, "0");
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    },
    async onClickStop(){
      if( window.confirm("本当に削除してもよろしいでしょうか？") ){
        await this.$store.state.acrylicTicketCouponManager.deleteEventData(this.settingData.docId);
        this.$store.commit("setCenterViewState", CenterViewState.EventList);
      }
    },
    onClickHelp(){
      window.open('https://www.acry.jp/datacreationguide');
    },

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.acry-btn-sub {
  // margin: 10px;
  padding: 3px 30px;
  color: $primary-main-color;
  background-color: #ffffff;
  border: solid 2px $border-main-color;
  border-radius: 15px;
  font-size: 15px;
}

.input-required{
  width: 48px;
  height: 24px;
  background: $status-error-color;
  border-radius: 4px;
  color: #FFFFFF;
  font-size: 13px;
}

.uploadlabel {
  margin: 8px;
  padding: 6px;
  cursor: pointer;
  font-size: 15px;
  width: 267px;
  height: 40px;
  color: $primary-main-color;
  border: 2px solid $primary-main-color;
  border-radius: 100px;
  background: $background-white-color;
}

input[type="file"] {
  display: none;
}


.un-edited {
  background: #F8F8F8;
}


.txt {
  color: #8c9bc6;
  font-size: 14px;
}
.txtblack {
  color: #000000;
  font-size: 14px;
}
.line {
  color: #8C9BC6;
  background-color: #8C9BC6;
}
</style>


